import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetFilterComponent } from './widget-filter/widget-filter.component';
import { MaterialModuleMobi } from '../material/material.module';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import '@material/web/all';
import { SharedModule } from 'shared-library';
import { DataBoardWidgetComponent } from "./components/data-board.widget/data-board.widget.component";

@NgModule({
  declarations: [WidgetFilterComponent,DataBoardWidgetComponent],
  imports: [
    CommonModule,
    MaterialModuleMobi,
    FormsModule,
    NgSelectModule,
    SharedModule,
],
  schemas:[CUSTOM_ELEMENTS_SCHEMA],
  exports:[
    WidgetFilterComponent
  ]
})
export class WidgetCoreModule { }
